import { Pipe, PipeTransform } from '@angular/core';
import { UserType } from '@type/user.type';

@Pipe({
  name: 'fullName',
  standalone: true,
})
export class FullNamePipe implements PipeTransform {
  transform(value: UserType): string {
    if (!value) {
      return '';
    }

    return `${value.first_name} ${value.last_name}`;
  }
}
